// skip these web/status keys in Select Columns
const WEB_STATUS_EXCLUDED_KEYS = new Set([
    "mo",
    "ty",
    "onlineStatus",
    "connectedTime",
    "updatedTime",
    "nextUpdate",
    "errors",
    "warnings",
]);

const normalizeStatusColumnKey = (key) => (key === "ts" ? "createdAt" : key);

// deviceUsage from getDeviceUsagebyId
export const getAllowedStatusColumnKeysFromWebStatus = (webStatus) => {
    if (!webStatus || typeof webStatus !== "object" || Array.isArray(webStatus)) {
        return null;
    }

    const allowed = new Set(["createdAt"]);
    Object.keys(webStatus).forEach((key) => {
        if (WEB_STATUS_EXCLUDED_KEYS.has(key)) {
            return;
        }
        allowed.add(normalizeStatusColumnKey(key));
    });
    return allowed;
};

export const getDeviceStatusStorageKey = (deviceId) => {
    const id = String(deviceId || "").trim();
    return id ? `deviceStatus.visibleColumns.device.${id}` : "deviceStatus.visibleColumns";
};

/** Removes legacy global key from older builds (one shared list for all devices/categories). */
export const removeLegacyGlobalDeviceStatusColumnKey = () => {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem("deviceStatus.visibleColumns");
};

/** Called on logout / token refresh — see auth.js and tokenRefresh.js */
export const clearDeviceStatusColumnPreferences = () => {
    if (typeof localStorage === "undefined") return;
    Object.keys(localStorage)
        .filter((key) => key === "deviceStatus.visibleColumns" || key.startsWith("deviceStatus.visibleColumns."))
        .forEach((key) => localStorage.removeItem(key));
};

const PREFERRED_DEFAULT_COLUMNS = ["createdAt", "ps", "actmp", "acmd", "states", "actions"];

const pickDefaults = (allowedKeys) => {
    const fallback = ["createdAt", "ps", "actions"];
    const preferred = PREFERRED_DEFAULT_COLUMNS.filter(
        (key) => !allowedKeys?.size || allowedKeys.has(key)
    );
    if (preferred.length > 0) {
        return preferred;
    }
    return fallback.filter((key) => !allowedKeys?.size || allowedKeys.has(key));
};

export const getDefaultVisibleColumnsForDevice = (allowedKeys = null) => pickDefaults(allowedKeys);

export const getDefaultColumnSequenceForDevice = (allowedKeys = null) =>
    getDefaultVisibleColumnsForDevice(allowedKeys);

export const isStatusColumnKeyAllowed = (key, allowedKeysFromWebStatus) => {
    const normalizedKey = normalizeStatusColumnKey(key);
    if (normalizedKey === "actions") {
        return true;
    }
    if (allowedKeysFromWebStatus?.size) {
        return allowedKeysFromWebStatus.has(normalizedKey);
    }
    return true;
};
